import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { auth, db } from '../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

const ProtectedRoute = ({ roles = [] }) => {
  const [authState, setAuthState] = useState({
    user: null,
    userData: null,
    loading: true,
    error: null
  });

  const location = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        console.warn('⚠️ No Firebase user. Session expired or not logged in.');
        sessionStorage.clear();
        setAuthState({
          user: null,
          userData: null,
          loading: false,
          error: 'Session expired'
        });
        return;
      }

      try {
        const authToken = sessionStorage.getItem('authToken');
        const userId = sessionStorage.getItem('userId');
        const roles = sessionStorage.getItem('userRole');

        if (!authToken || !userId) {
          throw new Error('No active session');
        }

        const userDoc = await getDoc(doc(db, 'users', userId));
        if (!userDoc.exists()) {
          throw new Error('User data not found');
        }

        const userData = userDoc.data();
        if (!userData.isActive) {
          throw new Error('Account deactivated');
        }

        if (roles.length > 0 && (!userData.role || !roles.includes(userData.role))) {
          throw new Error('Unauthorized access');
        }

        setAuthState({
          user,
          userData,
          loading: false,
          error: null
        });

      } catch (error) {
        console.error('Auth check error:', error);
        sessionStorage.clear();
        setAuthState({
          user: null,
          userData: null,
          loading: false,
          error: error.message
        });
      }
    });

    return () => unsubscribe();
  }, [roles]);

  if (authState.loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>refreshing...</p>
      </div>
    );
  }
  

  if (authState.error) {
    return <Navigate to="/login" state={{ from: location, error: authState.error }} replace />;
  }

  if (!authState.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
